(() => {
  const body = document.body;
  const header = document.querySelector('[data-bdc-header]');
  const megaToggle = document.querySelector('[data-bdc-mega-toggle]');
  const megaPanel = document.querySelector('[data-bdc-mega-panel]');
  const searchToggle = document.querySelector('[data-bdc-search-toggle]');
  const searchPanel = document.querySelector('[data-bdc-search-panel]');
  const searchClose = document.querySelector('[data-bdc-search-close]');
  const mobileOpen = document.querySelector('[data-bdc-mobile-open]');
  const mobileClose = document.querySelector('[data-bdc-mobile-close]');
  const mobileDrawer = document.querySelector('[data-bdc-mobile-drawer]');
  const overlay = document.querySelector('[data-bdc-overlay]');

  const setOverlay = (on) => overlay?.classList.toggle('is-visible', on);

  const setMega = (open) => {
    if (!megaPanel || !megaToggle) return;
    megaPanel.classList.toggle('is-open', open);
    megaPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
    megaToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    header?.classList.toggle('is-mega-open', open);
    setOverlay(open || mobileDrawer?.classList.contains('is-open'));
  };

  const setSearch = (open) => {
    if (!searchPanel || !searchToggle) return;
    searchPanel.classList.toggle('is-open', open);
    searchPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
    searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    header?.classList.toggle('is-search-open', open);
    if (open) {
      setMega(false);
      requestAnimationFrame(() => searchPanel.querySelector('input[type="search"]')?.focus());
    }
  };

  const setMobile = (open) => {
    if (!mobileDrawer || !mobileOpen) return;
    mobileDrawer.classList.toggle('is-open', open);
    mobileDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    mobileOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    body.classList.toggle('is-menu-open', open);
    if (open) {
      setMega(false);
      setSearch(false);
    }
    setOverlay(open || megaPanel?.classList.contains('is-open'));
  };

  megaToggle?.addEventListener('click', () => setMega(!megaPanel?.classList.contains('is-open')));
  searchToggle?.addEventListener('click', () => setSearch(!searchPanel?.classList.contains('is-open')));
  searchClose?.addEventListener('click', () => setSearch(false));
  mobileOpen?.addEventListener('click', () => setMobile(true));
  mobileClose?.addEventListener('click', () => setMobile(false));
  overlay?.addEventListener('click', () => { setMega(false); setSearch(false); setMobile(false); });
  mobileDrawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMobile(false)));
  document.querySelectorAll('[data-bdc-mega-open]').forEach((button) => button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.setTimeout(() => setMega(true), 320);
  }));

  /* Desktop mega menu tabs */
  const megaTabs = [...document.querySelectorAll('[data-bdc-mega-tab]')];
  const megaTabPanels = [...document.querySelectorAll('[data-bdc-mega-panel-index]')];
  const activateMegaTab = (index) => {
    megaTabs.forEach((tab) => {
      const active = tab.dataset.bdcMegaTab === String(index);
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    megaTabPanels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.bdcMegaPanelIndex === String(index)));
  };
  megaTabs.forEach((tab) => {
    tab.addEventListener('mouseenter', () => activateMegaTab(tab.dataset.bdcMegaTab));
    tab.addEventListener('click', () => activateMegaTab(tab.dataset.bdcMegaTab));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setMega(false);
      setSearch(false);
      setMobile(false);
      closeLightbox();
    }
  });

  document.addEventListener('click', (event) => {
    if (!header?.contains(event.target) && megaPanel?.classList.contains('is-open')) setMega(false);
  });

  document.querySelectorAll('.bdc-products, [data-bdc-home-products]').forEach((section) => {
    const rail = section.querySelector('[data-bdc-product-rail]');
    const prev = section.querySelector('[data-bdc-rail-prev]');
    const next = section.querySelector('[data-bdc-rail-next]');
    if (!rail) return;
    const amount = () => Math.max(rail.clientWidth * 0.78, 320);
    prev?.addEventListener('click', () => rail.scrollBy({ left: -amount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => rail.scrollBy({ left: amount(), behavior: 'smooth' }));
  });

  document.querySelectorAll('[data-bdc-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.closest('form')?.submit());
  });

  /* Product detail gallery */
  const productRoot = document.querySelector('[data-bdc-product-root]');
  if (productRoot) {
    const mainImage = productRoot.querySelector('.bdc-product-main-image');
    const thumbs = [...productRoot.querySelectorAll('[data-bdc-thumb]')];
    const select = productRoot.querySelector('[data-bdc-variant-select]');
    const priceNode = productRoot.querySelector('[data-bdc-product-price]');
    const compareNode = productRoot.querySelector('[data-bdc-product-compare]');
    const saleNode = productRoot.querySelector('[data-bdc-product-sale]');
    const statusNode = productRoot.querySelector('[data-bdc-product-status]');
    const addButton = productRoot.querySelector('[data-bdc-add-button]');

    const switchImage = (thumb) => {
      if (!thumb || !mainImage) return;
      mainImage.classList.add('is-switching');
      const src = thumb.dataset.imageSrc;
      const srcset = thumb.dataset.imageSrcset;
      const alt = thumb.dataset.imageAlt || '';
      window.setTimeout(() => {
        if (src) mainImage.src = src;
        if (srcset) mainImage.srcset = srcset;
        mainImage.alt = alt;
        mainImage.classList.remove('is-switching');
      }, 90);
      thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => switchImage(thumb)));

    select?.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      if (option.dataset.price && priceNode) priceNode.textContent = option.dataset.price;
      const compare = option.dataset.compare || '';
      if (compareNode) {
        compareNode.textContent = compare;
        compareNode.classList.toggle('is-hidden', !compare);
      }
      saleNode?.classList.toggle('is-hidden', !compare);
      const available = option.dataset.available === 'true';
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Kosárba teszem' : 'Elfogyott';
      }
      if (statusNode) {
        statusNode.classList.toggle('is-soldout', !available);
        statusNode.innerHTML = `<span></span>${available ? 'Raktáron / rendelhető' : 'Jelenleg nem elérhető'}`;
      }
      const mediaId = option.dataset.mediaId;
      if (mediaId) {
        const matchedThumb = thumbs.find((thumb) => thumb.dataset.mediaId === mediaId);
        if (matchedThumb) switchImage(matchedThumb);
      }
    });

    const qty = productRoot.querySelector('[data-bdc-quantity] input');
    productRoot.querySelector('[data-bdc-qty-minus]')?.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Math.max(Number(qty.min || 1), Number(qty.value || 1) - 1);
    });
    productRoot.querySelector('[data-bdc-qty-plus]')?.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Number(qty.value || 1) + 1;
    });
  }

  /* Image lightbox */
  const lightbox = document.querySelector('[data-bdc-lightbox]');
  const lightboxImage = lightbox?.querySelector('[data-bdc-lightbox-image]');
  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    body.classList.remove('is-menu-open');
  };
  document.querySelector('[data-bdc-zoom-open]')?.addEventListener('click', () => {
    const image = document.querySelector('.bdc-product-main-image');
    if (!lightbox || !lightboxImage || !image) return;
    lightboxImage.src = image.currentSrc || image.src;
    lightboxImage.alt = image.alt || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    body.classList.add('is-menu-open');
  });
  document.querySelector('[data-bdc-zoom-close]')?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });
})();
